import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, computedFrom, Disposable } from 'aurelia-framework';
import { AccountListItemVM, IAccountListItemTagAM } from '../account-api';
import { AccountTagService, IAccountTagAM } from '../account-tag-api';

@autoinject
export class AccountListTags {
	@bindable account: AccountListItemVM;
	@bindable accountTags: IAccountTagAM[];
	@bindable onRemoved: (params: any) => void;
	filteredTags: IAccountTagAM[];
	selectListOpen = false;
	onBodyClick: (Event) => void;
	dropdownOpenedSubscriber: Disposable;

	dropDownContents: HTMLElement;

	constructor(
		private accountTagService: AccountTagService,
		private eventAggregator: EventAggregator) {

		this.onBodyClick = () => { this.close(); };
	}

	attached() {
		document.addEventListener('click', this.onBodyClick);

		this.dropdownOpenedSubscriber =
			this.eventAggregator.subscribe('dropdownOpened', (viewModel: any) => {
				if (viewModel !== this) {
					this.close();
				}
			});

		this.filterVisibleTags();
	}

	detached() {
		document.removeEventListener('click', this.onBodyClick);

		this.dropdownOpenedSubscriber.dispose();
	}

	filterVisibleTags() {
		const createFilterer =
			(selectedTags: IAccountListItemTagAM[]) =>
				(tag: IAccountTagAM) =>
					selectedTags.every(st => st.id !== tag.id);

		const filterer = createFilterer(this.account.accountTags);

		this.filteredTags = this.accountTags.filter(filterer);
	}

	onToggleClick(event: Event) {
		event.stopPropagation();
		this.toggleSelectList();

		if (this.selectListOpen) {
			this.dropDownContents.classList.remove('reverse');
			const rect = this.dropDownContents.getBoundingClientRect();
			if(rect.top > document.documentElement.clientHeight / 2) {
				this.dropDownContents.classList.add('reverse');
			}
			this.eventAggregator.publish('dropdownOpened', this);
		}
	}

	toggleSelectList() {
		this.selectListOpen = !this.selectListOpen;
	}

	select(accountTag: IAccountTagAM) {
		const previousAccountTags = this.account.accountTags;

		this.close();

		if (accountTag == null) {
			return;
		}

		this.account.accountTags = this.account.accountTags.concat({
			id: accountTag.id,
			nameText: accountTag.nameText,
			code: accountTag.code
		});
		this.filterVisibleTags();

		this.accountTagService.addTagForAccount(
			this.account.id,
			accountTag.id)
			.then((response) => {
				if (!response.ok) {
					this.account.accountTags = previousAccountTags;
					this.filterVisibleTags();
				}
			});
	}

	close() {
		this.selectListOpen = false;
	}

	removeTag(tag: IAccountListItemTagAM) {
		const previousAccountTags = this.account.accountTags;

		this.account.accountTags = this.account.accountTags
			.filter(t => t.id !== tag.id);
		this.filterVisibleTags();

		this.accountTagService.removeTagFromAccount(this.account.id, tag.id)
			.then(response => {
				if (response.ok) {
					if (this.onRemoved) {
						this.onRemoved({ tag });
					}
				} else {
					this.account.accountTags = previousAccountTags;
					this.filterVisibleTags();
				}
			});
	}
}
